import '@descope-ui/descope-image';

import { componentName, IconClass } from './IconClass';

customElements.define(componentName, IconClass);

export { IconClass, componentName };
